
import Screenmirroring from "../../../assets/outline/Screenmirroring.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ScreenmirroringIcon({ className, dataTestid = "ScreenmirroringIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Screenmirroring data-testid={dataTestid} className={classes} {...rest} />
  );
}
